export {
  InputBackgroundColor,
  InputComponent,
  InputSize,
  InputTextAlign,
  InputType,
} from './input.component';

// FIXME: T63333 Remove InputComponent
